import { valueStoreFactory } from 'services/utils/valueStoreFactory';

export const chatSessionIdValueStore = valueStoreFactory();
